import {useQuery} from 'react-query';
import {getLabTests} from '../../../../../services/shop/lab';

const UseGetTests = (activityIds: string) => {
  const {
    data: labTests,
    isLoading,
    isSuccess,
  } = useQuery(['labTests', activityIds], getLabTests);
  return {labTests, isLoading, isSuccess};
};

export default UseGetTests;
